import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Header from './components/Header';
import Footer from './components/Footer';
import GameLoader from './components/GameLoader';
import HomePage from './pages/HomePage';
import Register from './pages/Register';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <div className="App min-h-screen bg-background text-foreground">
          <AnimatePresence mode="wait">
            {isLoading ? (
              <GameLoader key="loader" onComplete={handleLoadingComplete} />
            ) : (
              <>
                <Header />
                <main className="ml-0 lg:ml-24 pt-16 lg:pt-0">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/legal/privacy" element={<Privacy />} />
                    <Route path="/legal/refund" element={<Refund />} />
                  </Routes>
                </main>
                <Footer />
                <Toaster position="top-right" richColors />
              </>
            )}
          </AnimatePresence>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
